import { useStorylineSettings } from '../storylineSettings';

type UseCanCurrentUserAccessStoryline = () => boolean;
export const useCanCurrentUserAccessStoryline: UseCanCurrentUserAccessStoryline = () => {
  const storylineSettings = useStorylineSettings();

  return !!storylineSettings?.viewerCanAccessStoryline;
};
